module.exports = __webpack_public_path__ + "img/school.0c82048c.png";